import { asStringArray, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.identity.perms.UserRole
 *
 * @typedef {object} UserRoleData
 * @property {string} identifier
 * @property {string} title
 * @property {string} description
 * @property {string[]} abilities Jackson Set<UserAbility>
 * @property {string[]} requiredProducts Jackson Set<Product>
 */

/**
 * @param {object} raw
 * @param {string} [fallbackIdentifier] Map key from GET /api/roles/fetch
 * @returns {UserRoleData}
 */
export function fromUserRoleData(raw, fallbackIdentifier) {
  const source = requireObject(raw, 'UserRole');
  const identifier = (typeof source.identifier === 'string' && source.identifier)
    || fallbackIdentifier;
  if (typeof identifier !== 'string' || identifier.length === 0) {
    throw new Error('UserRole: identifier is required');
  }

  return {
    identifier,
    title: typeof source.title === 'string' ? source.title : identifier,
    description: typeof source.description === 'string' ? source.description : '',
    abilities: asStringArray(source.abilities),
    requiredProducts: asStringArray(source.requiredProducts),
  };
}

/**
 * @param {unknown} raw Map keyed by role identifier
 * @returns {Object<string, UserRoleData>}
 */
export function fromUserRoleMap(raw) {
  if (raw == null) {
    return {};
  }
  if (typeof raw !== 'object' || Array.isArray(raw)) {
    throw new Error('UserRole map: expected an object');
  }

  const roles = {};
  Object.entries(raw).forEach(([roleId, roleData]) => {
    roles[roleId] = fromUserRoleData(roleData, roleId);
  });
  return roles;
}
